<template>
  <div style="align-content: end">
    <!-- Используется для настройки и стилизации тултипа -->
    <!-- v-model="showTooltip" -->
    <v-tooltip
      v-if="tipByKey"
      :open-delay="openDelay"
      :location="tooltipLocation"
      :content-class="tooltipClasses"
      :offset="tooltipOffset"
      :content-props="tooltipContentProps"
      :transition="false"
    >
      <template v-slot:activator="{ props }">
        <span v-bind="props">
          <slot></slot>
        </span>
      </template>
      <span>{{ tipByKey.text }}</span>
    </v-tooltip>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "tooltips-component",

  props: {
    keyTips: {
      type: String,
      default: "",
    },
    attachTo: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    showTooltip: true,
  }),

  computed: {
    tooltipLocation() {
      return this.tipByKey?.position || "top";
    },
    tooltipOffset() {
      if (!this.tipByKey) return 0;
      const x = (this.tipByKey.nudgeRight || 0) - (this.tipByKey.nudgeLeft || 0);
      const y = (this.tipByKey.nudgeBottom || 0) - (this.tipByKey.nudgeTop || 0);

      const loc = this.tooltipLocation;
      if (loc === "bottom") return y;
      if (loc === "top") return -y;
      if (loc === "right") return x;
      if (loc === "left") return -x;

      return 0;
    },
    tooltipContentProps() {
      if (!this.tipByKey) return {};
      const x = (this.tipByKey.nudgeRight || 0) - (this.tipByKey.nudgeLeft || 0);
      const y = (this.tipByKey.nudgeBottom || 0) - (this.tipByKey.nudgeTop || 0);

      const loc = this.tooltipLocation;
      let style = {};

      if (loc === "bottom" || loc === "top") {
        if (x !== 0) style.marginLeft = `${x}px`;
      } else if (loc === "left" || loc === "right") {
        if (y !== 0) style.marginTop = `${y}px`;
      }

      return { style };
    },

    tooltipClasses() {
      if (!this.tipByKey) {
        return this.contentClass ? `zarbo-tips ${this.contentClass}` : "zarbo-tips";
      }

      let classes = ["zarbo-tips"];

      classes.push(`tooltip-${this.tipByKey.position}`);

      if (this.contentClass) {
        classes.push(this.contentClass);
      }

      return classes.join(" ");
    },

    tipByKey() {
      return this.$tips.tips.find((tip) => tip.key === this.keyTips) || null;
    },
    openDelay() {
      if (!this.tipByKey) return this.$tips.openDelay;
      if (Object.prototype.hasOwnProperty.call(this.tipByKey, "openDelay")) {
        return this.tipByKey.openDelay;
      }
      return this.$tips.openDelay;
    },
  },
};
</script>

<style lang="scss">
.zarbo-tips {
  border-bottom: 2px solid #9e92cf;
  background: rgb(var(--v-theme-border)) !important;
  // padding: 8px 12px !important;
  opacity: 1 !important;
  height: 32px;
  border-radius: 10px !important;
  span {
    color: rgb(var(--v-theme-primary));
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
// Стрелки
.tooltip-bottom::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 96%;
  transform: translateX(-50%);
  width: 24px;
  height: 12px;
  background: url("../../assets/img/arrow-tips.svg") no-repeat center center;
  background-size: contain;
}

.tooltip-left::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -17px;
  transform: translateY(-50%) rotate(90deg);
  width: 24px;
  height: 12px;
  background: url("../../assets/img/arrow-tips.svg") no-repeat center center;
  background-size: contain;
}
.tooltip-right::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -15px;
  transform: translateY(-50%) rotate(-90deg);
  width: 24px;
  height: 12px;
  background: url("../../assets/img/arrow-tips.svg") no-repeat center center;
  background-size: contain;
}

// Стили для тултипа главной страницы
.zarbo-tips__home-page {
  background-color: rgb(var(--v-theme-primary)) !important;
  border-bottom: 0;
  span {
    font-size: 15px;
    color: #fff;
  }
}
.tooltip-right__home-page::before {
  transform: translateY(-50%);
  background: url("../../assets/img/arrow-tips-home-page.svg") no-repeat center center;
}
</style>
